const aopRoutes = [
  {
    path: "/aop",
    component: () => import("../views/AOP/aop_layout.vue"),
    meta: { auth: true },
    redirect: "/aop/master-configurator",
    children: [
      {
        path: "master-configurator",
        name: "AopMasterConfigurator",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/MasterConfigurator/master_configurator_landing.vue"),
      },
      {
        path: "master-configurator/add",
        name: "AopMasterConfiguratorAdd",
        meta: { auth: true, page_type: "add" },
        component: () => import("../views/AOP/MasterConfigurator/master_configurator_add.vue"),
      },
      {
        path: "master-configurator/:table_name/data",
        name: "AopMasterConfiguratorView",
        meta: { auth: true, page_type: "data" },
        component: () => import("../views/AOP/MasterConfigurator/master_configurator_view.vue"),
      },
      {
        path: "master-configurator/:id/settings",
        name: "AopMasterConfiguratorSettings",
        meta: { auth: true, page_type: "settings" },
        component: () => import("../views/AOP/MasterConfigurator/master_configurator_settings.vue"),
      },
      {
        path: "master-configurator/:table_name/upload",
        name: "AopMasterConfiguratorUpload",
        meta: { auth: true, page_type: "upload" },
        component: () => import("../views/AOP/MasterConfigurator/master_configurator_upload.vue"),
      },
      {
        path: "master-configurator/:id/rights",
        name: "AopMasterConfiguratorRights",
        meta: { auth: true, page_type: "rights" },
        component: () => import("../views/AOP/MasterConfigurator/master_configurator_rights.vue"),
      },
      {
        path: "template-builder",
        name: "AopTemplateBuilder",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/TemplateBuilder/template_builder_landing.vue"),
      },
      {
        path: "template-builder/add",
        name: "AopTemplateBuilderAdd",
        meta: { auth: true, page_type: "add" },
        component: () => import("../views/AOP/TemplateBuilder/template_builder_add.vue"),
      },
      {
        path: "template-builder/:table_name/data",
        name: "AopTemplateBuilderView",
        meta: { auth: true, page_type: "data" },
        component: () => import("../views/AOP/TemplateBuilder/template_builder_view.vue"),
      },
      {
        path: "template-builder/:id/settings",
        name: "AopTemplateBuilderSettings",
        meta: { auth: true, page_type: "settings" },
        component: () => import("../views/AOP/TemplateBuilder/template_builder_settings.vue"),
      },
      {
        path: "template-builder/:table_name/upload",
        name: "AopTemplateBuilderUpload",
        meta: { auth: true, page_type: "upload" },
        component: () => import("../views/AOP/TemplateBuilder/template_builder_upload.vue"),
      },
      {
        path: "template-builder/:id/rights",
        name: "AopTemplateBuilderRights",
        meta: { auth: true, page_type: "rights" },
        component: () => import("../views/AOP/TemplateBuilder/template_builder_rights.vue"),
      },
      {
        path: "summary-configurator",
        name: "AopSummaryConfigurator",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/SummaryConfigurator/summary_configurator_landing.vue"),
      },
      {
        path: "summary-configurator/add",
        name: "AopSummaryConfiguratorAdd",
        meta: { auth: true, page_type: "add" },
        component: () => import("../views/AOP/SummaryConfigurator/summary_configurator_add.vue"),
      },
      {
        path: "summary-configurator/:id/editor",
        name: "AopSummaryConfiguratorEditor",
        meta: { auth: true, page_type: "editor" },
        component: () => import("../views/AOP/SummaryConfigurator/summary_configurator_editor.vue"),
      },
      {
        path: "summary-configurator/rights",
        name: "AopSummaryConfiguratorRights",
        meta: { auth: true, page_type: "rights" },
        component: () => import("../views/AOP/resource_rights.vue"),
      },
      {
        path: "inputs",
        name: "AopInputs",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/Inputs/inputs_landing.vue"),
      },
      {
        path: "forecast",
        name: "AopForecast",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/Forecast/forecast_landing.vue"),
      },
      {
        path: "forecast/add",
        name: "AopForecastAdd",
        meta: { auth: true, page_type: "add" },
        component: () => import("../views/AOP/Forecast/forecast_add.vue"),
      },
      {
        path: "forecast/rights",
        name: "AopForecastRights",
        meta: { auth: true, page_type: "rights" },
        component: () => import("../views/AOP/resource_rights.vue"),
      },
      {
        path: "forecast/:id/versions",
        name: "AopForecastVersions",
        meta: { auth: true, page_type: "versions" },
        component: () => import("../views/AOP/Forecast/forecast_versions.vue"),
      },
      {
        path: "forecast/:id/:versions_id/edit",
        name: "AopForecastEdit",
        meta: { auth: true, page_type: "editor" },
        component: () => import("../views/AOP/Forecast/forecast_add.vue"),
      },
      {
        path: "forecast/:id/:version_id/view",
        name: "AopForecastVersionView",
        meta: { auth: true, page_type: "view" },
        component: function() { return import("../views/AOP/Forecast/forecast_version_view.vue"); },
      },
      {
        path: "summary",
        name: "AopSummary",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/Summary/summary_landing.vue"),
      },
      {
        path: "financial-statement",
        name: "AopFinancialStatement",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/FinancialStatement/financial_statement_landing.vue"),
      },
      {
        path: "financial-statement/add",
        name: "AopFinancialStatementAdd",
        meta: { auth: true, page_type: "add" },
        component: () => import("../views/AOP/FinancialStatement/financial_statement_add.vue"),
      },
      {
        path: "financial-statement/:id/editor",
        name: "AopFinancialStatementEditor",
        meta: { auth: true, page_type: "editor" },
        component: () => import("../views/AOP/FinancialStatement/financial_statement_editor.vue"),
      },
      {
        path: "financial-statement/rights",
        name: "AopFinancialStatementRights",
        meta: { auth: true, page_type: "rights" },
        component: () => import("../views/AOP/resource_rights.vue"),
      },
      {
        path: "budget-summary",
        name: "AopBudgetSummary",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/BudgetSummary/budget_summary_landing.vue"),
      },
      {
        path: "budget-summary/add",
        name: "AopBudgetSummaryAdd",
        meta: { auth: true, page_type: "add" },
        component: () => import("../views/AOP/BudgetSummary/budget_summary_add.vue"),
      },
      {
        path: "budget-summary/:id/:version_id/edit",
        name: "AopBudgetSummaryEdit",
        meta: { auth: true, page_type: "edit" },
        component: () => import("../views/AOP/BudgetSummary/budget_summary_add.vue"),
      },
      {
        path: "budget-summary/:id/versions",
        name: "AopBudgetSummaryVersions",
        meta: { auth: true, page_type: "versions" },
        component: () => import("../views/AOP/BudgetSummary/budget_summary_versions.vue"),
      },
      {
        path: "budget-vs-actual",
        name: "AopBudgetVsActual",
        meta: { auth: true, page_type: "landing" },
        component: function() { return import("../views/AOP/BudgetVsActual/budget_vs_actual_landing.vue"); },
      },
      {
        path: "budget-vs-actual/:id/view",
        name: "AopBudgetVsActualView",
        meta: { auth: true, page_type: "view" },
        component: function() { return import("../views/AOP/BudgetVsActual/budget_vs_actual_view.vue"); },
      },
      {
        path: "budget-vs-actual/:id/actuals",
        name: "AopBudgetVsActualActuals",
        meta: { auth: true, page_type: "actuals" },
        component: function() { return import("../views/AOP/BudgetVsActual/budget_vs_actual_actuals.vue"); },
      },
      {
        path: "budget-vs-actual/:id/versions",
        name: "AopBudgetVsActualVersions",
        meta: { auth: true, page_type: "versions" },
        component: function() { return import("../views/AOP/BudgetVsActual/budget_vs_actual_versions.vue"); },
      },
      {
        path: "financials-plan",
        name: "AopFinancialPlan",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/FinancialPlan/financial_plan_landing.vue"),
      },
      {
        path: "financials-plan/add",
        name: "AopFinancialPlanAdd",
        meta: { auth: true, page_type: "add" },
        component: () => import("../views/AOP/FinancialPlan/financial_plan_add.vue"),
      },
      {
        path: "financials-plan/:id/:version_id/edit",
        name: "AopFinancialPlanEdit",
        meta: { auth: true, page_type: "edit" },
        component: () => import("../views/AOP/FinancialPlan/financial_plan_add.vue"),
      },
      {
        path: "financials-plan/:id/versions",
        name: "AopFinancialPlanVersions",
        meta: { auth: true, page_type: "versions" },
        component: () => import("../views/AOP/FinancialPlan/financial_plan_versions.vue"),
      },
      {
        path: "financials-vs-actual",
        name: "AopFinancialPlanVsActual",
        meta: { auth: true, page_type: "landing" },
        component: function() { return import("../views/AOP/FinancialPlanVsActual/financial_plan_vs_actual_landing.vue"); },
      },
      {
        path: "financials-vs-actual/:id/view",
        name: "AopFinancialPlanVsActualView",
        meta: { auth: true, page_type: "view" },
        component: function() { return import("../views/AOP/FinancialPlanVsActual/financial_plan_vs_actual_view.vue"); },
      },
      {
        path: "financials-vs-actual/:id/actuals",
        name: "AopFinancialPlanVsActualActuals",
        meta: { auth: true, page_type: "actuals" },
        component: function() { return import("../views/AOP/FinancialPlanVsActual/financial_plan_vs_actual_actuals.vue"); },
      },
      {
        path: "financials-vs-actual/:id/versions",
        name: "AopFinancialPlanVsActualVersions",
        meta: { auth: true, page_type: "versions" },
        component: function() { return import("../views/AOP/FinancialPlanVsActual/financial_plan_vs_actual_versions.vue"); },
      },
      {
        path: "actuals-mapping",
        name: "AopActualsMapping",
        meta: { auth: true, page_type: "landing" },
        component: function() { return import("../views/AOP/ActualsMapping/actuals_mapping_landing.vue"); },
      },
      {
        path: "actuals-mapping/edit",
        name: "AopActualsMappingEdit",
        meta: { auth: true, page_type: "edit" },
        component: function() { return import("../views/AOP/ActualsMapping/actuals_mapping_editor.vue"); },
      },
      {
        path: "change-log",
        name: "AopChangeLog",
        meta: { auth: true, page_type: "landing" },
        component: function() { return import("../views/AOP/Dashboard/aop_change_log.vue"); },
      },
      {
        path: "dashboard",
        name: "AopDashboard",
        meta: { auth: true, page_type: "landing" },
        component: () => import("../views/AOP/Dashboard/aop_dashboard.vue"),
      },
    ],
  },
];

export default aopRoutes;
